<template>
  <div class="wrapper" :class="{ narrow }">
    <div class="button" :class="classes" @click="onClick">
      <span><slot></slot></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: () => 'black'
    },
    type: {
      type: String,
      default: () => 'outline'
    },
    size: {
      type: String,
      default: () => 'normal'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    solid: {
      type: Boolean,
      default: false
    },
    narrow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      let cls = [this.color, this.type, this.size];
      if (this.disabled) {
        cls.push('disabled');
      }
      if (this.solid) {
        cls.push('solid');
      }
      return cls;
    }
  },
  methods: {
    onClick(e) {
      this.$emit('click', e);
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  &.narrow {
    text-align: center;

    .button {
      display: inline-flex;
    }
  }
}

.button {
  align-items: center;
  border: 3px solid $black;
  border-radius: 40px;
  color: $black;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin: 10px 0;
  min-height: 60px;
  padding: 0 10px;
  user-select: none;
  text-align: center;
  padding: 5px;

  &.white {
    border-color: $white;

    span {
      color: $white;
    }
  }

  &.green {
    border-color: $green;

    &.outline {
      span {
        color: $green;
      }
    }
  }

  &.solid {
    background-color: $green;
    border: 0;
    color: $white;

    &.brown {
      background-color: $brown;
    }

    &.black {
      background-color: $black;
    }

    &.pink {
      background: #ff929a;
      color: black;
    }
  }

  &.small {
    min-height: 0;
    padding: 10px 25px;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.3;
    pointer-events: none;
  }

  span {
    font-size: 18px;
    letter-spacing: 0.9px;
    line-height: 140%;
    font-weight: 800;
    position: relative;
    text-decoration: none;
    text-transform: uppercase;
    top: 1px;
  }
}
</style>
